import { defineContract } from "../defineContract";
import { SOCKET_EVENTS } from "../socketEvents";

/**
 * Conexão como as telas usam (seleção em modal de campanha, lista de
 * conexões). O model Whatsapp tem muito mais coluna — inclusive o blob de
 * sessão, que NÃO trafega: as rotas de lista usam `?session=0`.
 */
export interface WhatsappDTO {
  id: number;
  name: string;
  status: string;
  channel: string;
  isDefault: boolean;
  companyId: number;
  qrcode?: string;
  /** Backend que sobe/aciona esta conexão (env SERVER_ID). Null = órfã. */
  serverId?: string | null;
  /**
   * Presente só em GET /whatsapp/all (tela de super-admin, parque inteiro):
   * se ESTE backend consegue agir sobre a conexão. False = mostrar apagada,
   * sem ações; qualquer ação responde WHATSAPP_ERRORS.OTHER_SERVER
   * (ver errors/whatsapp) (#4418).
   */
  managedByThisServer?: boolean;
}


/** Payload de SOCKET_EVENTS.WHATSAPP.CHANGED — WhatsAppController. */
export type WhatsappEventPayload =
  | { action: "update"; whatsapp: WhatsappDTO }
  | { action: "delete"; whatsappId: number };

/**
 * Payload de SOCKET_EVENTS.WHATSAPP.SESSION — estado da sessão.
 *
 * É o evento de maior frequência do sistema: cada troca de status e cada
 * qrcode novo passa por aqui.
 */
export interface WhatsappSessionPayload {
  action: string;
  session?: WhatsappDTO;
}

export const whatsappContract = defineContract<
  { session?: 0 | 1; companyId?: number },
  WhatsappDTO[],
  WhatsappEventPayload
>({
  route: "/whatsapp",
  method: "GET",
  events: {
    changed: SOCKET_EVENTS.WHATSAPP.CHANGED,
    session: SOCKET_EVENTS.WHATSAPP.SESSION
  },
  // O TTL mais curto do conjunto, e não por mudar muito (contacts muda mais):
  // errar aqui faz alguém disparar campanha por uma conexão morta. E os DOIS
  // fatos derrubam — `session` é quem carrega status e qrcode.
  cache: { ttl: 20 * 1000, invalidatedBy: ["changed", "session"] }
});

/**
 * GET /whatsapp/:whatsappId/transferable-tickets — tickets que impedem a
 * exclusão da conexão (abertos, pendentes, de grupo). Facebook/Instagram
 * contam todas as conexões do mesmo token, que são excluídas juntas.
 */
export interface WhatsappTransferableTicketsDTO {
  count: number;
}

export const whatsappTransferableTicketsContract = defineContract<void, WhatsappTransferableTicketsDTO>({
  route: "/whatsapp/:whatsappId/transferable-tickets",
  buildRoute: (whatsappId: number | string) => `/whatsapp/${whatsappId}/transferable-tickets`,
  method: "GET"
});
